import Heading from './Heading';

export type { HeadingProps } from './Heading';
export default Heading;
